"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Check if a field value is not same as another field value, if no specific field is passed it will return true.
 * @param message
 * @param fieldID
 * @returns {function({field: *})}
 */
var isNotEqualTo = function isNotEqualTo(message, fieldID) {
  return function (_ref) {
    var field = _ref.field,
        form = _ref.form;

    // This is not an 'isRequired' validator
    if (!field.value) {
      return true;
    }

    var isValid = true;
    var enteredValue = field.value;

    if (fieldID) {
      var compareValue = form.$(fieldID).value;

      if (enteredValue === compareValue) {
        isValid = false;
      }
    }

    return [isValid, message || 'Value cannot be equal to other field.'];
  };
};

var _default = isNotEqualTo;
exports.default = _default;
//# sourceMappingURL=isNotEqualTo.js.map